import { Playground } from 'docz';
import { Breadcrumb } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Breadcrumb,
  React
};